/* eslint-disable */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiUrl } from 'App.js';

export const fetchParentFavoriteCategory = createAsyncThunk(
  'get_parent_favorite_category/post',
  async (arg, thunkAPI) => {
    const { categoryId } = arg;
    const { channel } = thunkAPI.getState().currentchannel;
    const res = await axios.post(
      `${apiUrl}category/return_parent_favorite_category`,
      {
        category_id: categoryId,
        channel: channel
      }
    );
    return res.data;
  }
);

const parentFavoriteCategorySlice = createSlice({
  name: 'parentFavoriteCategories',
  initialState: {
    parentFavoriteCategoryAmazon: [],
    parentFavoriteCategoryRakuten: [],
    parentFavoriteCategoryYahoo: [],
    test: { value: 'aaa', label: 'bbb' }
  },
  reducers: {
    changeFavoriteCategoryLabel: (state, action) => {
      return {
        ...state.test,
        test: action.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchParentFavoriteCategory.fulfilled, (state, action) => {
      if (action.payload.channel == 1) {
        state.parentFavoriteCategoryAmazon =
          action.payload.parentFavorite_categories_amazon;
        state.parentFavoriteCategoryRakuten =
          state.parentFavoriteCategoryRakuten;
        state.parentFavoriteCategoryYahoo = state.parentFavoriteCategoryYahoo;
      } else if (action.payload.channel == 2) {
        state.parentFavoriteCategoryAmazon = state.parentFavoriteCategoryAmazon;
        state.parentFavoriteCategoryRakuten =
          action.payload.parentFavorite_categories_rakuten;
        state.parentFavoriteCategoryYahoo = state.parentFavoriteCategoryYahoo;
      } else if (action.payload.channel == 2) {
        state.parentFavoriteCategoryAmazon = state.parentFavoriteCategoryAmazon;
        state.parentFavoriteCategoryRakuten =
          state.parentFavoriteCategoryRakuten;
        state.parentFavoriteCategoryYahoo =
          action.payload.parentFavorite_categories_yahoo;
      }
    });
  }
});

// export const {
//   selectCategory1
// } = fetchCategoryGraphSlice.actions;

export const amazonParentFavoriteCategory = (state) =>
  state.parentFavoriteCategories.parentFavoriteCategoryAmazon;
export const rakutenParentFavoriteCategory = (state) =>
  state.parentFavoriteCategories.parentFavoriteCategoryRakuten;
export const yahooParentFavoriteCategory = (state) =>
  state.parentFavoriteCategories.parentFavoriteCategoryYahoo;
export const testParentFavoriteCategory = (state) =>
  state.parentFavoriteCategories.test;

export const { changeFavoriteCategoryLabel } =
  parentFavoriteCategorySlice.actions;

export default parentFavoriteCategorySlice.reducer;
